import { render } from "./PremiumFeature.vue?vue&type=template&id=622e4607"
import script from "./PremiumFeature.vue?vue&type=script&lang=js"
export * from "./PremiumFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__